import axios from 'axios';
import { F1PasswordManagement, GetF1PasswordManagementRequest, UpdateF1PasswordManagementRequest } from '../schemas';

export async function getAll(params: GetF1PasswordManagementRequest) {
    return axios.get<F1PasswordManagement[]>('/v1/config/f1password-management', {
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export function updateF1PasswordConfig(body: UpdateF1PasswordManagementRequest) {
    return axios.post<string>('/v1/config/f1password-management',
        body,
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
            }
        }
    );
}
